/**
 * @chordbaker/design - Typography
 *
 * Shared typography tokens for ChordBaker applications.
 * Source of truth: React Native app (ThemeContext.tsx).
 *
 * These values are platform-agnostic (numbers, not rem/px strings)
 * so they work in both React Native and web contexts.
 */
export const typographySizes = {
    xs: 10,
    sm: 12,
    md: 14,
    lg: 16,
    xl: 18,
    xxl: 20,
    xxxl: 24,
    xxxxl: 32,
    display: 48,
};
export const typographyWeights = {
    light: '300',
    normal: '400',
    medium: '500',
    semiBold: '600',
    bold: '700',
};
export const typographyLineHeights = {
    tight: 1.2,
    normal: 1.4,
    relaxed: 1.6,
};
// Web font stacks — used by web-app and buffet.
export const typographyFamilies = {
    sans: "'Inter', system-ui, -apple-system, sans-serif",
    mono: "'JetBrains Mono', ui-monospace, Menlo, monospace",
    chord: "'JetBrains Mono', ui-monospace, Menlo, monospace",
};
// React Native equivalents — empty `sans` falls back to the system font
// (San Francisco on iOS, Roboto on Android). `Courier` is already used in
// JohanChatModal for code blocks; keep consistency until/unless a bundled
// font is shipped with the app.
export const typographyFamiliesNative = {
    sans: '',
    mono: 'Courier',
    chord: 'Courier',
};
export const typography = {
    sizes: typographySizes,
    weights: typographyWeights,
    lineHeights: typographyLineHeights,
    families: typographyFamilies,
};
